import React, { useEffect, useState } from "react";
import axiosClient from "../api/axiosClient";

const initialForm = { name: "", slug: "" };

const Categories = () => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [form, setForm] = useState(initialForm);
    const [editingId, setEditingId] = useState(null);
    const [saving, setSaving] = useState(false);
    
    useEffect(() => {
        fetchCategories();
    }, []);
    
    const fetchCategories = async () => {
        setLoading(true);
        try {
            const res = await axiosClient.get("/categories/");
            setCategories(res.data.data || []);
        } finally {
            setLoading(false);
        }
    };
    
    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };
    
    const handleAdd = async (e) => {
        e.preventDefault();
        if (!form.name || !form.slug) {
            alert("Please enter category name and slug.");
            return;
        }
        setSaving(true);
        try {
            const res = await axiosClient.post("/categories/", form);
            setCategories([...categories, res.data.data]);
            setForm(initialForm);
        } catch {
            alert("Failed to add category.");
        } finally {
            setSaving(false);
        }
    };
    
    const startEdit = (cat) => {
        setEditingId(cat.id);
        setForm({ name: cat.name, slug: cat.slug });
    };
    
    const cancelEdit = () => {
        setEditingId(null);
        setForm(initialForm);
    };
    
    const handleUpdate = async (e) => {
        e.preventDefault();
        if (!form.name || !form.slug) {
            alert("Please enter category name and slug.");
            return;
        }
        setSaving(true);
        try {
            const res = await axiosClient.put(`/categories/${editingId}`, form);
            setCategories(categories.map((cat) => (cat.id === editingId ? res.data.data : cat)));
            cancelEdit();
        } catch {
            alert("Failed to update category.");
        } finally {
            setSaving(false);
        }
    };
    
    const handleDelete = async (id) => {
        if (!window.confirm("Delete this category?")) return;
        try {
            await axiosClient.delete(`/categories/${id}`);
            setCategories(categories.filter((cat) => cat.id !== id));
        } catch {
            alert("Failed to delete category.");
        }
    };
    
    return (
        <div className="container mt-4" style={{ maxWidth: "600px" }}>
            <h2 className="mb-4">Categories</h2>
            
            <div className="card mb-4">
                <div className="card-body">
                    <form className="row g-2 align-items-end" onSubmit={editingId ? handleUpdate : handleAdd}>
                        <div className="col">
                            <input
                                type="text"
                                className="form-control"
                                name="name"
                                placeholder="Category Name"
                                value={form.name}
                                onChange={handleChange}
                                required
                                disabled={saving}
                            />
                        </div>
                        <div className="col">
                            <input
                                type="text"
                                className="form-control"
                                name="slug"
                                placeholder="Slug"
                                value={form.slug}
                                onChange={handleChange}
                                required
                                disabled={saving}
                            />
                        </div>
                        <div className="col-auto">
                            {editingId ? (
                                <>
                                    <button type="submit" className="btn btn-success btn-sm me-2" disabled={saving}>Save</button>
                                    <button type="button" className="btn btn-secondary btn-sm" onClick={cancelEdit} disabled={saving}>Cancel</button>
                                </>
                            ) : (
                                <button type="submit" className="btn btn-primary btn-sm" disabled={saving}>Add</button>
                            )}
                        </div>
                    </form>
                </div>
            </div>
            
            <div className="table-responsive">
                <table className="table table-striped align-middle">
                    <thead>
                    <tr>
                        <th>Name</th>
                        <th>Slug</th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    {categories.length === 0 ? (
                        <tr>
                            <td colSpan={3} className="text-center">No categories yet.</td>
                        </tr>
                    ) : (
                        categories.map((cat) => (
                            <tr key={cat.id}>
                                <td>{cat.name}</td>
                                <td>{cat.slug}</td>
                                <td>
                                    <button className="btn btn-sm btn-outline-primary me-2" onClick={() => startEdit(cat)}>
                                        Edit
                                    </button>
                                    <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(cat.id)}>
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))
                    )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Categories;
